import {
    useMemo,
} from 'react'
import {
    createRoutesConfig,
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useCreateSkyNetDomainRoutes, {
    SkyNetDomainSubRoutes,
} from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    LocationType,
} from 'app/enums/label.enums'
import {
    App,
    ContactManagementDomains,
    CompaniesTabs,
    LocationsTabs,
    ContactsTableTabs,
    AirportsAndSeaportsDomains, BillingCompaniesTabs,
} from 'app/enums/domain.enums'
import {
    createChildEditRoutes,
} from 'app/shared-components/SkyNetDomain'
import {
    getTabUrl,
} from 'app/Apps/ContactManagement/Locations/Locations.config'

export default function useContactManagementRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const createSkyNetDomainRoutes = useCreateSkyNetDomainRoutes()

    return useMemo(() => {
        const SkyNetDomainRoutes = createSkyNetDomainRoutes()
        const locationsTabs = {
            Overview: CommonRoutes.Overview,
            Update: CommonRoutes.DataUpdate,
            Areas: LocationsTabs.Areas,
            ChangeHistory: CommonRoutes.ChangeHistory,
        }
        const config = {
            path: [App.ContactManagement],
            Companies: {
                route: ContactManagementDomains.Companies,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                SkyMind: {
                    route: CompaniesTabs.SkyMind,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Tracking: {
                    route: CompaniesTabs.Tracking,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            Locations: {
                route: ContactManagementDomains.Locations,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Areas: {
                    route: LocationsTabs.Areas,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Address: {
                    route: getTabUrl(LocationType.ADDRESS),
                    Edit: {
                        route: SkyNetDomainRoutes.All.Edit.route,
                        params: [{
                            name: 'key',
                            required: true,
                        }],
                        Update: {
                            route: CommonRoutes.DataUpdate,
                        },
                    },
                },
                Create: {
                    route: null,
                    via: SkyNetDomainRoutes.All.Create,
                },
            },
            BillingCompanies: {
                route: ContactManagementDomains.BillingCompanies,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                CustomerSalesArea: {
                    route: BillingCompaniesTabs.CustomerSalesArea,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                SalesAreaTax: {
                    route: BillingCompaniesTabs.SalesAreaTax,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Communication: {
                    route: BillingCompaniesTabs.Communication,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Abacus: {
                    route: BillingCompaniesTabs.Abacus,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Create: {
                    route: null,
                    via: SkyNetDomainRoutes.All.Create,
                },
            },
            AirportsAndSeaports: {
                route: ContactManagementDomains.AirportsAndSeaports,
                ...createChildEditRoutes(
                    createSkyNetDomainRoutes(AirportsAndSeaportsDomains),
                )(locationsTabs),
            },
            Contacts: {
                route: ContactManagementDomains.Contacts,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Create: {
                    route: null,
                    via: SkyNetDomainRoutes.All.Create,
                },
                Prospect: {
                    route: ContactsTableTabs.Prospect,
                    Edit: {
                        route: SkyNetDomainSubRoutes.EDIT,
                        params: [{
                            name: 'key',
                            required: true,
                        }],
                        Overview: {
                            route: CommonRoutes.Overview,
                        },
                    },
                },
            },
            Countries: {
                route: ContactManagementDomains.Countries,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            Users: {
                route: ContactManagementDomains.Users,
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        createSkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
